import { render, staticRenderFns } from "./NameTransfer.vue?vue&type=template&id=e9bcc614&scoped=true"
import script from "./NameTransfer.vue?vue&type=script&lang=js"
export * from "./NameTransfer.vue?vue&type=script&lang=js"
import style0 from "./NameTransfer.vue?vue&type=style&index=0&id=e9bcc614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bcc614",
  null
  
)

export default component.exports